import { Form, Select } from 'antd';
import { useContext } from 'react';

import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';
import { EXPERIENCE_ACCESS_MODE } from 'app/typings/core/admin/experiences/enum/experienceAccessMode';
import { capitalizeFirstLetter } from 'app/utils/string';

const { Option } = Select;
const RULES = [{ required: true, message: 'Required' }];

export const AccessMode = () => {
  const { isEditMode } = useContext(ViewEditModeContext);

  const form = Form.useFormInstance();
  const accessModeValue = Form.useWatch('accessMode', form);

  return (
    <FormLineLayout label="Access mode" isRequired disabled={!isEditMode}>
      <Form.Item name="accessMode" rules={RULES}>
        {isEditMode ? (
          <Select showSearch>
            {Object.values(EXPERIENCE_ACCESS_MODE).map((mode) => (
              <Option key={mode} value={mode}>
                {capitalizeFirstLetter(mode.replace(/_/g, ' ').toLowerCase())}
              </Option>
            ))}
          </Select>
        ) : (
          <span className="view-data">
            {capitalizeFirstLetter(
              (accessModeValue ?? '').replace(/_/g, ' ').toLowerCase()
            ) || 'ø empty'}
          </span>
        )}
      </Form.Item>
    </FormLineLayout>
  );
};
